// extracted by mini-css-extract-plugin
export default {"container":"ToggleButtons_container__LQ3sC","paymentStatusBtn":"ToggleButtons_paymentStatusBtn__D3na-","green":"ToggleButtons_green__xEWtw","red":"ToggleButtons_red__tEdCJ"};